import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController, App } from 'ionic-angular';
//import { AdministerPage } from '../administer/administer';
import { Assessment } from '../../models/assessment';
import { Items } from '../../providers/providers';
import { UserAccount } from '../../models/account';
//import { AdministerPage } from '../administer/administer';
/**
 * Generated class for the SelectAssessmentPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 * the tags module is from https://github.com/HsuanXyz/ionic-tags-input
 */


@IonicPage()
@Component({
  selector: 'page-select-assessment',
  templateUrl: 'select-assessment.html',
})
export class SelectAssessmentPage {

  clientId: string;
  clientName: string;
  batteryName: string;
  clientEmail: string;
  clientEmail2: string;
  batteryDesc: string;
  assessments: Assessment[];
  assessmentsTag: Assessment[] = [];
  assessmentNameTag = [];
  assessment: Assessment;
  selected = [];
  isReadyToSend: boolean;
  userAccountData: UserAccount;
  isBattery: boolean = false;
  recipient: string = '0';

  selectedAssessments: { short_name: string, extended_name: string } = {
    short_name: 'First Name',
    extended_name: 'Last Name'
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public items: Items, public alertCtrl: AlertController, public appCtrl: App) {
    // this.items.getAssessmentList().subscribe(res => {
    //   if (res) {
    //     this.assessments = res; 
    //   }
    // }, err => {
    //   console.error('ERROR', err);
    // });
  }

  ionViewDidLoad() {
    this.items.getAssessmentList().subscribe(res => {
      if (res) {
        this.assessments = res;
        if (this.navParams.data.batteryAssessments) {
          for (let i = 0; i < this.navParams.data.batteryAssessments.length; i++) {
            var assessmentId = this.navParams.data.batteryAssessments[i];
            var assessment = this.getAssessmentForId(assessmentId);
            this.assessmentSelected(assessment);
          }
        }
        if (this.navParams.data.assessment) {
          var selectedAssessment = this.getAssessmentForId(this.navParams.data.assessment.id);
          this.assessmentSelected(selectedAssessment);
        }
      }
    }, err => {
      console.error('ERROR', err);
    });
    if (this.navParams.get('client')) {
      this.clientId = this.navParams.get('client').clientId;
      this.clientName = this.navParams.get('client').clientName
      this.clientEmail = this.navParams.get('client').clientEmail;
      this.clientEmail2 = this.navParams.get('client').clientEmail2;
    }
    if (this.navParams.get('battery')) {
      this.isBattery = true;
    }

    // this.assessment = this.navParams.get('assessment');
    // if(this.assessment != undefined){
    //   console.log('inside if ');
    //   this.assessments = this.items.getAssessments();
    //   var assessment = this.getAssessmentForId(this.assessment.id);
    //   this.assessmentSelected(assessment);
    // }
  }

  getAssessmentForId(assessmentId) {
    return this.assessments.find(x => x.id == assessmentId);
  }

  cancel() {
    this.assessmentsTag.length = 0;
    for (let assessment of this.assessments) {
      assessment.selected = false;
    }
    this.viewCtrl.dismiss();
  }

  assessmentSelected(item) {
    this.isReadyToSend = true;
    var index = this.assessmentsTag.indexOf(item);
    if (index > -1) {
      this.assessmentsTag.splice(index, 1);
      this.assessmentNameTag.splice(index, 1);
      item.selected = false;
      if (this.assessmentsTag.length == 0) {
        this.isReadyToSend = false;
      }
    } else {
      //little hack to display the tag name
      // item.selected = true;
      this.assessmentsTag.push(item);
      this.assessmentNameTag.push(item.short_name);
      item.selected = true;
    }

  }

  onChange(val) {
    // 10/06/2019 val always return the array after deleting the element. 
    //1. assign the assessmentsTag to a temp array and then find the index of deleted element. delete all other elements except the removed element
    //2. set the selected property to false and find it's index in the temp array.
    //3. delete the index from temp array and assign it back to assessmentsTag array
    // Can be done in one line like below but how to set the selected property to false ?
    // var filteredArray = this.assessmentsTag.filter(e=> val.includes(e.short_name));
    // console.log(filteredArray);
    var tempArray = new Array<Assessment>();
    tempArray = this.assessmentsTag.slice();
    for (let i = 0; i < val.length; i++) {
      var name = val[i];
      var index = this.assessmentsTag.findIndex(x => x.short_name == name);
      if (index > -1) {
        this.assessmentsTag.splice(index, 1);
      }
    }
    this.assessmentsTag[0].selected = false;
    var index = tempArray.findIndex(i => i.short_name === this.assessmentsTag[0].short_name);
    tempArray.splice(index, 1);
    this.assessmentsTag = tempArray;
    if (this.assessmentsTag.length == 0) {
      this.isReadyToSend = false;
    }
    // var index = this.assessmentsTag.indexOf(val);
    // if (index > -1) {
    //   this.assessmentsTag.splice(index,1);
    //   this.assessmentNameTag.splice(index,1);
    //   if(this.assessmentsTag.length == 0){
    //     this.isReadyToSend = false;
    //   }
    // }
    // }
  }

  filterAssessments(ev) {
    var val = ev.target.value;
    this.assessments = this.items.getAssessments(val);
    return this.assessments;

  }

  administer(item) {
    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.userAccountData = res;
        if (parseInt(this.userAccountData.max_assessments) - parseInt(this.userAccountData.monthly_administered_assessments) < 4 ||
          parseInt(this.userAccountData.monthly_administered_assessments) > parseInt(this.userAccountData.max_assessments)) {
          this.presentAlert();
        } else {
          // this.viewCtrl.dismiss();
          // this.appCtrl.getRootNav().push('administer', {clientName: this.clientName,assessments:this.assessmentsTag, clientId:this.clientId})
          //added on 10/06/2020
          this.appCtrl.navPop();
          this.appCtrl.getRootNavs()[0].push('administer', { clientName: this.clientName, assessments: this.assessmentsTag, clientId: this.clientId, is_parent_2: this.recipient,index:0 })
          // this.appCtrl.navPop();
          // this.navCtrl.push('administer', {clientName: this.clientName,assessments:this.assessmentsTag, clientId:this.clientId});
        }
      }
    }, err => {
      console.error('ERROR', err);
    });

  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      title: parseInt(this.userAccountData.max_assessments) - parseInt(this.userAccountData.monthly_administered_assessments) + ' tests left on your limit',
      subTitle: 'You are currently on the ' + this.userAccountData.chargebee_plan + ' Plan, which allows you to have ' + this.userAccountData.max_assessments + ' tests. You have administered ' + this.userAccountData.monthly_administered_assessments + ' tests so far. ' + 'Would you like to upgrade to increase your limit?',
      buttons: [
        {
          text: 'Later',
          handler: data => {
            // console.log('Cancel clicked');
            if (parseInt(this.userAccountData.monthly_administered_assessments) < parseInt(this.userAccountData.max_assessments)) {
              this.appCtrl.navPop();
              this.viewCtrl.dismiss();
              this.appCtrl.getRootNavs()[0].push('administer', { clientName: this.clientName, assessments: this.assessmentsTag, clientId: this.clientId, parent2: this.recipient, index:0 })
              //this.navCtrl.push('administer', { clientName: this.clientName, assessments: this.assessmentsTag, clientId: this.clientId });
            }
          }
        },
        {
          text: 'Upgrade',
          handler: data => {
            this.navCtrl.push('account');
          }
        }
      ]
    });
    alert.present();
  }

  saveBattery() {
    this.viewCtrl.dismiss(this.assessmentsTag);
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-assessment/select-assessment.ts